<!--
 * @Author: xiehangyi
 * @LastEditors: chenming
 * @Description: 金额
-->
<template>
  <div class="lc-input-money">
    <el-input
      class="lc-input"
      type="number"
      v-model="val"
      v-bind="$attrs"
      @input.native="inputMoneyFun($event)"
      @change="v => $emit('change', v)"
      @blur="e => $emit('blur', e)"
      @focus="e => $emit('focus', e)"
      @clear="$emit('clear')"
    >
      <component
        :is="append.componentName" v-for="append in appends" :key="append.id"
        slot="append" v-bind="append.props"
      />
    </el-input>
    <div v-if="val" class="lc-input-money__uppercase">
      {{ val | amountInWords }}
    </div>
  </div>
</template>
<script>
import { amountInWords } from '@/utils/index';
export default {
  name: 'LcInputMoney',
  filters:{
    amountInWords
  },
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    //最大整数位数
    maxIntegerDigits: {
      type: [Number, String],
      default: 12
    },
    //最大小数点位数
    maxDecimalDigits: {
      type: [Number, String],
      default: 4
    },
    appends: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      val: ''
    };
  },
  watch: {
    // 接收绑定的值
    value: {
      immediate: true,
      handler: function(val) {
        this.val = val;
      }
    }
  },
  created() {},
  methods: {
    inputMoneyFun(e) {
      //保存整数的情况 由于输入小数点触发改变 故用原生native事件会触发改变
      if (this.maxDecimalDigits && Number(this.maxDecimalDigits) === 0) {
        e.target.value = e.target.value.replace('.', '')
        this.val = e.target.value;
        return
      }
      this.formattedAmountFun(e.target.value);
      this.$emit('input', this.val)
    },
    formattedAmountFun(val) {
      const NumArr = val.toString().split('.');
      let integer = Array.isArray(NumArr) && NumArr.length > 0 ? NumArr[0].length > this.maxIntegerDigits ? NumArr[0].slice(0, this.maxIntegerDigits) : NumArr[0] : '',
        decimal = Array.isArray(NumArr) && NumArr.length === 2 ? NumArr[1].length > this.maxDecimalDigits ? NumArr[1].slice(0, this.maxDecimalDigits) : NumArr[1] : '';

      if (integer && !decimal) {
        this.val = NumArr.length > 1 ? `${integer}.` : integer
      } else if (!integer && decimal) {
        this.val = `0.${decimal}`
      } else if (integer && decimal) {
        this.val =`${integer}.${decimal}`
      }
    },
  },
};
</script>
